import { useMemo, useContext } from "react";

import { Navigate, Outlet } from "react-router-dom";

import { UserContext } from "App/contexts";
import { AppPagePaths } from "App/routes/paths";

export default function AdminRouter(): JSX.Element {
    const { user } = useContext(UserContext);
    const email = user?.email;

    // TODO: Move this to an actual user permissions based model
    // renamed this so it wasn't confused with the isAdmin from usePageAvailability, which is based on roles and permissions, not email allowlist
    const isRegalAllowlisted = useMemo<boolean>(() => {
        if (!email) {
            return false;
        }

        return (
            /@regalvoice\.com$/i.test(email) ||
            /@regal\.io$/i.test(email) ||
            (window.location.hostname.startsWith("app.staging") && /@qawolf\.com/i.test(email))
        );
    }, [email]);

    if (!isRegalAllowlisted) {
        return <Navigate to={AppPagePaths.fallback} />;
    }

    return <Outlet />;
}
